<script setup lang="ts">
import { router } from "@inertiajs/vue3"
import { useTranslation } from "i18next-vue"
import type { PagesHome } from "@/types/serializers"
import { currentAccount as currentAccountRoute } from "@/routes"
import { Button } from "@/components/ui/button"

const props = defineProps<PagesHome>()
const { t } = useTranslation()

const switchAccount = (accountId: number) => {
  router.patch(currentAccountRoute().url, { accountId })
}
</script>

<template>
  <div class="space-y-6">
    <h1>{{ t("navigation.home") }}</h1>
    <div>
      <p>{{ t("accounts.current", { name: props.currentAccount.name }) }}</p>
      <p>
        {{ t("accounts.signed_in", { email: props.currentUser.emailAddress }) }}
      </p>
    </div>

    <section v-if="props.accounts.length > 0" class="space-y-2">
      <h2>{{ t("accounts.switch_to") }}</h2>
      <div class="flex flex-wrap gap-2">
        <Button
          v-for="account in props.accounts"
          :key="account.id"
          variant="outline"
          @click="switchAccount(account.id)"
        >
          {{ account.name }}
        </Button>
      </div>
    </section>
  </div>
</template>
